import { render, staticRenderFns } from "./InputTextName.vue?vue&type=template&id=cbdf51d6&"
import script from "./InputTextName.vue?vue&type=script&lang=js&"
export * from "./InputTextName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports